export enum ButtonSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
}